<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalEmployees",
	components: { CaseForm },
	computed: {
		schema() {
			return [
				{
					label: "3. (a) Number of Employees",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0EmployeesQuantityId",
					props: {
						suggest: {
							typeIncludes: "employeesQuantity"
						},
						createOptions: {
							type: "employeesQuantity",
							dataType: "string"
						}
					}
				},
				{
					label:
						"3. (b) What is the minimum number of employees including principals in the sales section of your premises at any time during business hours, including lunchtime?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SalesEmployeesId",
					props: {
						suggest: {
							typeIncludes: "salesEmployees"
						},
						createOptions: {
							type: "salesEmployees",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
